import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import Text from '@/shared-components/text/components/Text';

import './styles/SearchMoreCard.css';

export default function SearchMoreCard({ actionLabel, message, onClick, style = {} }) {
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.();
  };

  return (
    <div className="search-more-card element-non-selectable" style={style} onClick={handleClick}>
      <div className="search-more-card__content">
        <Text className="search-more-card__message dots-on-overflow">
          {message}
        </Text>
        <ContinueButton className="search-more-card__action" onClick={handleClick}>
          {actionLabel}
        </ContinueButton>
      </div>
    </div>
  );
}
